var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.593.126L.49 10.57a.938.938 0 00.086 1.688l4.151 1.741 11.22-9.888c.216-.192.52.101.337.324L6.876 15.896v3.144c0 .922 1.113 1.285 1.66.617l2.48-3.019 4.866 2.04a.94.94 0 001.29-.712l2.811-16.871c.133-.79-.715-1.36-1.39-.969z"
  })));
}
export default SvgPaperPlane;